<template>
  <div class="data-update">
        <el-dialog :title="dataBulletin.id == 0 ? '新增' : '修改'" 
         :close-on-click-modal="false" 
         :visible.sync="dialogFormVisible"
          @close="dialogClose" style="text-align:left">
        <el-form 
            :model="dataBulletin" 
            label-width='80px' 
            ref="dataBulletin"
            :rules="newsRules"
            @keyup.enter.native="submitData"
        >
            <el-form-item label="标题" label-width="120px">
            <el-input 
                v-model="dataBulletin.timePeriod" 
                autocomplete="off"
            >
            </el-input>
            </el-form-item>
            <el-form-item label="数值" label-width="120px" prop="numericalValue">
            <el-input v-model="dataBulletin.numericalValue"  autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="描述" label-width="120px">
            <el-input v-model="dataBulletin.description" autocomplete="off" type="textarea" rows="3"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitData">确 定</el-button>
        </div>
        </el-dialog>
  </div>
</template>

<script>
export default {
     data() {
        return {
            dialogFormVisible: false,
            //数据快报修改或添加参数
            dataBulletin:{
                timePeriod:'',
                id:null,
                numericalValue:'',
                description:'',
                pid:0,
                showStatus:1
            },
            newsRules:{
                numericalValue: [ 
                { required: true, message: "数值不能为空", trigger: "blur" },
              ],
            }
        }
    },
    methods: {
        init(id){
            this.dialogFormVisible=true
            this.dataBulletin.id = id || 0;
            this.dataBulletin.pid = id || 0;
            this.dataBulletin.showStatus = id || 1;
            console.log( this.dataBulletin.id);
            this.$nextTick(() => {
            this.$refs["dataBulletin"].resetFields();
            if(this.dataBulletin.id){
                this.$ajaxGet(`/bulletin/info/${this.dataBulletin.id}`).then(({data}) => {
                    if(data.code ===0){
                        this.dataBulletin = data.data
                    }
                })
            }
            })
        },
         // 关闭对话框触发事件
    courseDialogClose() {
      this.$refs["dataBulletin"].resetFields();
      Object.keys(this.dataBulletin).forEach((item) => {
        if (item === "id") {
          this.dataBulletin[item] = null;
        } else if (item === "sort") {
          this.dataBulletin[item] = 0;
        } else {
          this.dataBulletin[item] = "";
        }
      });
    },
        //点击确定按钮
        submitData(){
            let that = this
            that.$refs['dataBulletin'].validate(valid => {
                if(valid){
                    let news = { ...that.dataBulletin };
                    console.log(news);
                    that.$ajaxPost(
                     `/bulletin/${news.id == 0 ? "saveDataBulletin" : "update"}`,
                    news).then(({data}) => {
                        if(data.code===0){ 
                            that.$emit('dataListUpdate')
                            that.dialogFormVisible = false
                            that.$message.success('修改成功')
                        }else{
                            that.$message.error(data.msg);
                        }         
                    })
                }
                else{
                    return false
                }
            })
        },
          // 对话框关闭的时候对表单进行重置
    dialogClose() {
    //   this.$refs.dataBulletin.resetFields();
      this.dataBulletin = {
                timePeriod:'',
                numericalValue:'',
                description:'',
      };
    },
    },
}
</script>